import React, {useState,useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import apiClient from '../api/apiClient'
import {useAuth} from '../context/AuthContext'


export default function TeacherExamList(props){
    const {user} = useAuth()
    const user_id = user.id

    const [testGroupList, setTestGroupList] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [currentStudentList, setCurrentStudentList] = useState([])

    async function fetchTestGroups(){
        console.log ("fetching etast groups with "+ user_id)
        try{
            const result = await apiClient.get('/api/testgroup/allteachersgroups', {
                params : {teacherID: user_id}
            })
            setTestGroupList(result.data)
        }catch(e){
            console.log("fejl ved hentning af lærers testgrupper")
            console.log(e)
        }
    }
   
    async function fetchStudentsWithExams(){
        console.log("fetching students for testgroup "+ currentTestGroup?.id)
        console.log(currentTestGroup)
        if(currentTestGroup){
            try{
                const result = await apiClient.get('/api/testgroup/getstudentsintestgroup',
                    {params: {testGroupID: currentTestGroup?.id || null}}
                )
                setCurrentStudentList(result.data)
            }catch(e){
                console.log(" error in getting students with exams")
                console.log(e)
            }   
        }
    }

    useEffect(()=>{
        fetchTestGroups()
        fetchStudentsWithExams()
    }, [currentTestGroup])

    const navigate = useNavigate()

    function handleStartGrading(){
        navigate('/my-teacherexamgrading', {state: {testGroupID: currentTestGroup.id}})
    }

    return(
        <div className="panel-container">
            <div className="panel">
                <select onChange={(e)=> setCurrentTestGroup(testGroupList.find(t=> t.id === parseInt(e.target.value)))}>
                    <option key="0" value="0">Ingen testgruppe valg</option>
                    {testGroupList.map(testGroup =>{
                        return(
                            <option key={testGroup.id} value={testGroup.id}>{testGroup.navn}</option>
                        )
                    })}
                </select>
                <span>
                    <b>Testgruppe: {currentTestGroup?.navn}</b>
                </span>
                {currentStudentList.length === 0 ? (
                    <p className="drop-zone-hint">Ingen kursister i prøvegruppe</p>
                ): (
                    <div>
                    <button type="button" onClick={handleStartGrading}>Start/forsæt karaktergivning</button>
                    <table className="censor-table">
                        <thead>
                            <th>Kursist ID</th>
                            <th>Fornavn(e)</th>
                            <th>Efternavn</th>
                            <th></th>
                        </thead>
                        <tbody>
                            { currentStudentList.map(student =>                                 
                                    (<tr>
                                        <td>{student.id}</td>
                                        <td>{student.fornavne}</td>
                                        <td>{student.efternavn}</td>
                                    </tr>)
                                
                            ) 
                            }
                        </tbody>
                    </table>
                    </div>
                )}
            </div>
        </div>
    )
}